<button class="button back-button">
    <a routerLink="/colours-of-magic/uses">
        <i class="fa-sharp fa-solid fa-caret-left"></i>
        Retour
    </a>
</button>

<div class="magic-pres">
    <div class="magic-title">
        Explosion
    </div>
    <div class="magic-stats">
        <div class="magic-purity">
            <div class="magic-inactive">pure</div>
            <div class="magic-active">combinée</div>
        </div>
        <div class="magic-tangibility">
            <div class="magic-inactive">Tangible</div>
            <div class="magic-active">intangible</div>
        </div>
        <div class="magic-det">
            <div>DET</div>
            <div>1</div>
        </div>
    </div>
</div>

<p></p>
